var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',_vm._l((_vm.parts),function(part,idx){return _c('span',{key:idx,class:part.class},[_vm._v(_vm._s(part.word))])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }